(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["aegant-collection-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('aegant-collection-showcase')) {
 customElements.define('aegant-collection-showcase', class extends HTMLElement {
  connectedCallback() {
   const track=this.querySelector('.agc__track');if(!track)return;
   this.abort=new AbortController();
   const buttons=[...this.querySelectorAll('.agc__arrow')],meter=this.querySelector('.agc__meter span');
   const update=()=>{const max=Math.max(0,track.scrollWidth-track.clientWidth),left=Math.max(0,track.scrollLeft);buttons[0].disabled=left<=2;buttons[1].disabled=left>=max-2;const portion=Math.min(1,track.clientWidth/track.scrollWidth);meter.style.width=`${portion*100}%`;meter.style.transform=`translateX(${max?left/max*(1/portion-1)*100:0}%)`;};
   const move=d=>{const card=track.querySelector('.agc__card');const step=card.getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap);track.scrollBy({left:d*step*Math.max(1,Math.floor((track.clientWidth+1)/step)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
   buttons.forEach(b=>b.addEventListener('click',()=>move(Number(b.dataset.direction)),{signal:this.abort.signal}));
   track.addEventListener('scroll',update,{passive:true,signal:this.abort.signal});
   track.addEventListener('keydown',e=>{if(e.target.closest('button,input'))return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},{signal:this.abort.signal});
   this.observer=new ResizeObserver(update);this.observer.observe(track);update();
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
